import { Paper } from "@mui/material";
import { useTheme } from "@mui/styles";
import { FBASummaryChart } from "./FBASummaryChart";
import { FBASummaryDataTable } from "./FBASummaryDataTable";
import { FBASummarySection } from "./FBASummarySection";

export const FBASummary = ({ fba, darkMode, units }) => {
  const theme = useTheme();

  return (
    <Paper 
      elevation={0}
      sx={{ boxShadow: 1 }}
      style={{ 
        flexBasis: 0, 
        flexShrink: 1, 
        flexGrow: 1, 
        margin: 10, 
        padding: 10,
        backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']
      }}>
      <FBASummarySection fba={fba} units={units} />
      <FBASummaryChart fba={fba} units={units} />
      <FBASummaryDataTable fba={fba} units={units} />

    </Paper>
  );
};